import * as wasm from "./registration_challenge_bg.wasm";
import { __wbg_set_wasm } from "./registration_challenge_bg.js";
__wbg_set_wasm(wasm);
export * from "./registration_challenge_bg.js";
